import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { ProvenanceDialog } from "./MetricProvenance";
import { MrcogDetail } from "./MrcogRollupCell";
import { MavcgDetail } from "./MavcgRollupCell";
import { InventoryMetricsDetail } from "./InventoryMetricsCell";
import { RestockDetail } from "./RestockStatusCell";

/**
 * The context menus' "Metric sources" dialog: one tab per computed product
 * metric, each showing the rows the value was computed from.
 */
export type MetricTab = "mrcog" | "mavcg" | "inventory" | "restock";

const TABS: Array<{ value: MetricTab; label: string }> = [
  { value: "mrcog", label: "MRCOG" },
  { value: "mavcg", label: "MAVCG" },
  { value: "inventory", label: "ATS / MAI / MONO" },
  { value: "restock", label: "Restock" },
];

export function MetricProvenanceDialog({
  open,
  onClose,
  product,
  initialTab = "mrcog",
}: {
  open: boolean;
  onClose: () => void;
  product: any;
  initialTab?: MetricTab;
}) {
  const [tab, setTab] = useState<MetricTab>(initialTab);
  const productId = product?.product_id;
  const productTitle = product?.product_title;
  return (
    <ProvenanceDialog open={open} onClose={onClose} title="Metric sources">
      <Tabs
        value={tab}
        onChange={(_e, next) => setTab(next)}
        sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
      >
        {TABS.map((t) => (
          <Tab key={t.value} value={t.value} label={t.label} />
        ))}
      </Tabs>
      <Box sx={{ minHeight: 160 }}>
        {tab === "mrcog" && (
          <MrcogDetail productId={productId} productTitle={productTitle} />
        )}
        {tab === "mavcg" && (
          <MavcgDetail productId={productId} productTitle={productTitle} />
        )}
        {tab === "inventory" && (
          <InventoryMetricsDetail
            productId={productId}
            productTitle={productTitle}
          />
        )}
        {tab === "restock" && (
          <RestockDetail productId={productId} productTitle={productTitle} />
        )}
      </Box>
    </ProvenanceDialog>
  );
}
